import autocomplete from 'autocompleter';
import escape from 'lodash.escape';

const initialize = () => {
    const input = document.getElementById('user');

    let timeout = null;
    autocomplete({
        input,
        minLength: 1,
        showOnFocus: true,
        fetch: (text, update) => {
            clearTimeout(timeout);

            timeout = setTimeout(() => {
                (async () => {
                    const mailboxSearchUrlPlaceHolder = input.getAttribute('data-url');
                    const selectedDomainName = document.querySelector('#origin_domain_id option:checked').textContent;

                    const mailboxSearchUrl = mailboxSearchUrlPlaceHolder.replace('__domain_placeholder__', selectedDomainName);

                    const response = await fetch(mailboxSearchUrl, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            user: input.value
                        })
                    });

                    update(await response.json());
                })();
            }, 200);
        },
        onSelect: (item) => {
            input.value = item.label;
            document.getElementById('userId').value = item.value;
        },
        render: (item, currentValue) => {
            const strRegExp = new RegExp(currentValue, 'g');
            let { label } = item;

            if (currentValue) {
                label = label.replace(strRegExp, `<b>${escape(currentValue)}</b>`);
            }

            const itemElement = document.createElement('div');
            itemElement.innerHTML = label;

            return itemElement;
        }
    });
};

export default initialize;
